import {ValueObject} from '@s-ui/domain'

export class TagCloudSeoRequest extends ValueObject {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.query
   * @param {String} param.endpoint
   **/
}
